const home = {
  'hero.eyebrow': 'Le centre de ressources USFans',
  'hero.title': 'USFans Spreadsheet — Trouvez produits, vendeurs et ressources d\'achat plus rapidement',
  'hero.subtitle': 'Explorez les ressources de la feuille de calcul USFans, les listes de produits, les informations sur les vendeurs, les avis, les guides d\'expédition et des ressources d\'achat pratiques au même endroit.',
  'hero.primaryCta': 'USFans Spreadsheet',
  'hero.secondaryCta': 'Acheter Maintenant',
  'hero.trust': 'Ressource indépendante • Mise à jour régulièrement • Conçue pour faciliter la recherche de produits',

  'category.browse': 'Parcourir les catégories',
  'category.label': 'Choisir une catégorie',
  'category.all': 'Toutes les catégories',
  'category.hint': 'Accédez directement à une catégorie de produits sur le site principal.',

  'categories.shoes': 'Chaussures',
  'categories.hoodies': 'Hoodies / Sweats',
  'categories.tshirts': 'T-Shirts',
  'categories.jackets': 'Vestes',
  'categories.pants': 'Pantalons / Shorts',
  'categories.headwear': 'Couvre-chefs',
  'categories.sets': 'Ensembles',
  'categories.underwear': 'Sous-vêtements',
  'categories.jersey': 'Maillots',
  'categories.accessories': 'Accessoires',
  'categories.bags': 'Sacs',
  'categories.belts': 'Ceintures',
  'categories.perfumes': 'Parfums',
  'categories.other': 'Autres articles',

  'whatis.title': 'Qu\'est-ce qu\'une feuille de calcul USFans ?',
  'whatis.copy': 'Une feuille de calcul USFans peut aider à organiser les informations sur les produits, les ressources des vendeurs et des références d\'achat utiles au même endroit. Notre objectif est de faciliter la recherche de produits en organisant les ressources USFans pertinentes en catégories, guides et comparaisons consultables.',
  'whatis.cta': 'Explorer le centre des feuilles de calcul',

  'why.title': 'Tout ce dont vous avez besoin pour une recherche USFans plus intelligente',
  'why.subtitle': 'Des ressources organisées conçues pour vous aider à rechercher des produits et des vendeurs avec plus de confiance.',
  'why.card1.title': 'USFans Spreadsheet',
  'why.card1.desc': 'Trouvez des ressources organisées de produits et de vendeurs au même endroit.',
  'why.card2.title': 'Annuaire des vendeurs',
  'why.card2.desc': 'Explorez les informations sur les vendeurs et les guides de recherche.',
  'why.card3.title': 'Guides de produits',
  'why.card3.desc': 'Découvrez des conseils de recherche spécifiques à chaque catégorie.',
  'why.card4.title': 'Avis USFans',
  'why.card4.desc': 'Comprenez les facteurs importants avant d\'utiliser un service ou une ressource.',
  'why.card5.title': 'Guides d\'expédition',
  'why.card5.desc': 'Découvrez les coûts, les méthodes et les considérations d\'expédition.',
  'why.card6.title': 'Centre de sécurité',
  'why.card6.desc': 'Apprenez à identifier les liens, offres et risques suspects.',

  'popular.title': 'Recherches USFans populaires',
  'popular.subtitle': 'Explorez les sujets les plus recherchés lors de l\'étude des ressources USFans.',
  'popular.1': 'Avis USFans',
  'popular.2': 'Coût d\'expédition USFans',
  'popular.3': 'Coupon USFans',
  'popular.4': 'Code promo USFans',
  'popular.5': 'Entrepôt USFans',
  'popular.6': 'USFans est-il légitime ?',
  'popular.7': 'USFans Spreadsheet',
  'popular.8': 'Guide des vendeurs USFans',

  'compare.title': 'Comparez les ressources USFans avant de décider',
  'compare.subtitle': 'Une référence rapide pour comprendre à quoi sert chaque ressource. Nous n\'inventons jamais de notes, de prix ou d\'affirmations de vérification.',
  'compare.col.resource': 'Ressource',
  'compare.col.category': 'Catégorie',
  'compare.col.info': 'À quoi ça sert',
  'compare.row1.resource': 'USFans Spreadsheet',
  'compare.row1.category': 'Recherche',
  'compare.row1.info': 'Organisation des informations sur les produits et les vendeurs',
  'compare.row2.resource': 'Annuaire des vendeurs',
  'compare.row2.category': 'Vendeurs',
  'compare.row2.info': 'Guide de recherche et de vérification des vendeurs',
  'compare.row3.resource': 'Guides de produits',
  'compare.row3.category': 'Produits',
  'compare.row3.info': 'Conseils de recherche de produits par catégorie',
  'compare.row4.resource': 'Guides d\'expédition',
  'compare.row4.category': 'Expédition',
  'compare.row4.info': 'Méthodes, coûts et considérations d\'expédition',
  'compare.row5.resource': 'Centre de sécurité',
  'compare.row5.category': 'Sécurité',
  'compare.row5.info': 'Sensibilisation aux risques et navigation sécurisée',

  'article.faqTitle': 'Questions fréquentes',
  'guides.title': 'Guides et tutoriels USFans',
  'guides.subtitle': 'Des guides originaux et détaillés pour vous aider à rechercher des produits et des vendeurs plus efficacement.',
  'guides.updated': 'Mis à jour',
  'guides.minRead': 'min de lecture',
  'guides.category.guide': 'Guide',
  'guides.category.review': 'Avis',
  'guides.category.shipping': 'Expédition',

  'safety.title': 'Restez en sécurité lors de la recherche de ressources USFans',
  'safety.copy': 'Vérifiez toujours de manière indépendante les sites web, les vendeurs, les liens, les informations de paiement et les détails des produits. Notre Centre de Sécurité explique les risques courants, notamment les sites suspects, les liens de phishing, les promotions trompeuses et les pratiques de navigation dangereuses.',
  'safety.cta': 'Visiter le Centre de Sécurité',
  'safety.point1': 'Vérifiez les sites et les liens de manière indépendante',
  'safety.point2': 'Ne partagez jamais les données de paiement ou de compte avec négligence',
  'safety.point3': 'Méfiez-vous des promotions trompeuses et des fausses offres',
  'safety.point4': 'Recherchez les vendeurs avant de décider',

  'final.title': 'Prêt à explorer USFans Spreadsheet ?',
  'final.copy': 'Commencez par le centre USFans Spreadsheet, comparez des ressources utiles et explorez des guides pratiques conçus pour rendre votre recherche plus rapide et plus facile.',
  'final.cta': 'Explorer USFans Spreadsheet',
  'final.secondary': 'Visiter le site principal',
};

export default home;